/**
 * NỘI DUNG TRANG SKILL TẠO VIDEO HỎI ĐÁP NHÀ THUỐC (/tools/tao-video-hoi-dap-nha-thuoc)
 *
 * Dùng chung trang VideoBatchToolPage với các công cụ video khác — cấu trúc trường giống videoBatchToolContent.js,
 * thêm sampleVideos (video mẫu xem trước) và các nhãn riêng cho skill (không phải phần mềm cài máy).
 *
 * File trên máy chủ: web/back-end/storage/tools/Bo-skill-tao-video-hoi-dap-nha-thuoc.zip (DESKTOP_TOOLS['qa-video-skill'],
 * pharmacy-tool.controller.js) — MỘT file gồm tao-video-concept-hoi-dap-cho-nha-thuoc.zip (khách giữ nguyên, tải lên ChatGPT),
 * HUONGDAN-tao-video-hoi-dap-nha-thuoc.pdf (ảnh đã nén) và DOC-TRUOC.txt. Bản gốc ở docs/goc-huong-dan-skill (không lên máy chủ).
 * Video mẫu là YouTube Shorts (sampleVideos), máy chủ không lưu video.
 * Tải bộ skill cần mua gói TOOL_VIDEO_HOI_DAP (50.000đ / 12 tháng, sheet "Hệ thống tool" dòng 9).
 * Các bước bên dưới tóm tắt từ HUONGDAN.pdf (B1–B12) và SKILL.md bản v64 — đổi bản skill thì đối chiếu lại.
 */
export const QA_VIDEO_SKILL_TOOL = {
  published: true,

  slug: 'tao-video-hoi-dap-nha-thuoc',
  contentFile: 'qaVideoSkillContent.js',
  name: 'Skill Tạo Video Hỏi Đáp Nhà Thuốc',
  kindLabel: 'SKILL CHATGPT + GOOGLE FLOW',
  tagline: 'Gõ một chủ đề, ChatGPT viết sẵn kịch bản hỏi nhanh đáp gọn; Google Flow dựng video dược sĩ trả lời, có phụ đề tiếng Việt',
  intro:
    'Cài skill vào ChatGPT một lần. Mỗi video: gõ chủ đề (sức khỏe, thuốc, kinh doanh nhà thuốc), chọn 1 trong 3 ý tưởng và lời kết, ' +
    'skill viết sẵn lời cho từng đoạn. Bạn dán lời sang Google Flow cùng ảnh nhân vật để tạo các đoạn video, gửi lại cho ChatGPT, ' +
    'skill tự xếp thứ tự, chèn phụ đề và ghép thành một video hoàn chỉnh khung dọc 9:16.',
  version: 'v64',
  fileSize: '',
  updatedAt: '17/10/2026',
  platforms: ['Máy tính có trình duyệt', 'ChatGPT', 'Google Flow'],
  image: '/images/tools/skill-video-hoi-dap.jpg',
  heroBanner: '/images/tools/skill-video-hoi-dap.jpg',

  downloadLabel: 'Tải bộ skill (.zip)',
  loginLabel: 'Đăng nhập để mua / tải skill',

  sampleVideos: [
    // YouTube Shorts (chỉ điền ID): youtube.com/shorts/dERlnswE6eE, youtube.com/shorts/EPPo4DJXrng
    { youtubeId: 'dERlnswE6eE', title: 'Video mẫu 1' },
    { youtubeId: 'EPPo4DJXrng', title: 'Video mẫu 2' },
  ],
  sampleVideosNote: 'Hai video làm ra từ skill: đoạn mở đầu, các cặp hỏi đáp có phụ đề và lời kết.',

  highlights: [
    { value: '1 chủ đề', label: 'ra trọn kịch bản: mở đầu, các cặp hỏi đáp, lời kết' },
    { value: '9:16', label: 'video dọc cho TikTok / Reels, có phụ đề tiếng Việt' },
    { value: 'Tự ghép', label: 'gửi các đoạn video lại, skill xếp, chèn chữ và ghép' },
  ],

  features: [
    { title: '3 ý tưởng cho mỗi chủ đề', desc: 'Skill đưa 3 ý tưởng và 4 lời kết để chọn, rồi viết lời cho từng đoạn video, ghi sẵn số giây của mỗi đoạn.' },
    { title: 'Hỏi nhanh, đáp gọn', desc: 'Mỗi đoạn là một cặp hỏi đáp: giọng nữ ngoài khung hình hỏi theo tình huống thật, nhân vật trong ảnh trả lời cụ thể.' },
    { title: 'Phụ đề đúng chính tả', desc: 'Phụ đề tiếng Việt cho cả câu hỏi (khung vàng) và câu trả lời (khung trắng), chạy theo đúng giọng nói.' },
    { title: 'Giữ đúng nhân vật', desc: 'Dùng ảnh nhân vật của bạn làm khung đầu, mọi đoạn giữ cùng góc máy như quay một mạch, có icon minh họa trên đầu.' },
  ],

  audience: [
    'Dược sĩ, chủ nhà thuốc làm kênh cá nhân chia sẻ kiến thức',
    'Nhân viên marketing nhà thuốc cần video hỏi đáp đều đặn mỗi tuần',
  ],

  requirements: [
    { label: 'ChatGPT', value: 'Tài khoản ChatGPT Plus có mục Plugin → Kỹ năng để tải skill lên' },
    { label: 'Google Flow', value: 'Tài khoản Google Flow (flow.google.com), dùng model Omni 1.1 Flash' },
    { label: 'Ảnh nhân vật', value: 'Ảnh chụp từ bụng trở lên, rõ mặt' },
    { label: 'Máy tính', value: 'Trình duyệt Chrome / Edge, Internet ổn định' },
  ],

  installTitle: 'Hướng dẫn dùng skill',
  installSubtitle: 'Tóm tắt các bước trong file hướng dẫn PDF (có ảnh chụp từng bước). Cài skill chỉ làm một lần.',
  installTabLabel: 'Các bước',

  installSteps: [
    {
      title: 'Tải bộ skill',
      desc: 'Bấm "Tải bộ skill (.zip)" rồi giải nén bộ này. Bên trong có file skill tao-video-concept-hoi-dap-cho-nha-thuoc.zip và file HUONGDAN-tao-video-hoi-dap-nha-thuoc.pdf.',
      tip: 'Chỉ giải nén bộ tải về. File skill .zip bên trong giữ nguyên, không giải nén. File hướng dẫn PDF có ảnh chụp từng bước, khung đỏ là chỗ bấm.',
    },
    {
      title: 'Cài skill vào ChatGPT (một lần)',
      desc: 'Vào chatgpt.com → thanh bên trái bấm Plugin → tab Kỹ năng → Thêm → Tải lên từ máy tính → chọn file skill tao-video-concept-hoi-dap-cho-nha-thuoc.zip → Mở. Thấy "Đã tải kỹ năng lên" là xong, bấm Xong.',
    },
    {
      title: 'Mở skill và gửi chủ đề',
      desc: 'Bấm Công việc, kéo mức nỗ lực sang phải. Trong ô chat gõ dấu / rồi chọn "tao video concept hoi dap cho nha thuoc". Gõ chủ đề, ví dụ: "Chủ đề: giữ chân khách cho nhà thuốc mới mở", rồi gửi.',
    },
    {
      title: 'Chọn số giây, ý tưởng và lời kết',
      desc: 'Skill hỏi số giây mỗi đoạn (nên chọn 10 giây) và giới tính nhân vật trong ảnh. Đọc 3 ý tưởng, gõ số ý tưởng thích nhất; đọc 4 lời kết, gõ số lời kết thích nhất. Skill viết sẵn lời cho từng video.',
    },
    {
      title: 'Tạo từng đoạn video trên Google Flow',
      desc: 'Vào flow.google.com → Dự án mới → dấu + để đưa ảnh nhân vật lên. Với từng đoạn: chép lời từ ChatGPT dán vào ô gõ chữ, chọn Video, 9:16, Omni 1.1 Flash, Khung hình → gắn ảnh nhân vật → chọn đúng số giây → bấm mũi tên tạo video.',
      tip: 'Số giây phải đúng như ghi trong ngoặc của từng đoạn, ví dụ (6s) thì chọn 6 giây. Sai số giây thì nhân vật bị cắt lời hoặc cuối video bị im lặng.',
    },
    {
      title: 'Tải các đoạn về và gửi lại cho ChatGPT',
      desc: 'Trong Flow, mỗi video bấm 3 chấm → Tải xuống → 720p, không đổi tên file. Quay lại đúng đoạn chat cũ, bấm + → Thêm ảnh & tệp, chọn hết các video vừa tải rồi gửi, không cần gõ gì.',
    },
    {
      title: 'Nhận video hoàn chỉnh',
      desc: 'Đợi vài phút: skill tự xếp thứ tự, chèn phụ đề và ghép thành một video. Bấm vào link để tải về, xem lại trước khi đăng.',
      tip: 'Làm video mới thì mở đoạn chat mới và bắt đầu lại từ bước mở skill.',
    },
  ],

  installStepsMac: [],

  youtubeVideoId: '',

  faqs: [
    {
      q: 'Skill giá bao nhiêu?',
      a: '50.000đ, dùng 12 tháng, tải bộ skill (skill + hướng dẫn PDF) về nhiều lần. Thanh toán bằng QR chuyển khoản, mở tải ngay sau khi chuyển khoản thành công. Phí dùng ChatGPT và Google Flow (nếu có) tính riêng theo tài khoản của bạn.',
    },
    {
      q: 'Có cần giải nén file .zip không?',
      a: 'Giải nén bộ vừa tải về (Bo-skill-...zip) để lấy file skill và file hướng dẫn. File skill tao-video-concept-hoi-dap-cho-nha-thuoc.zip bên trong thì giữ nguyên, tải lên ChatGPT nguyên file .zip.',
    },
    {
      q: 'Video bị cắt lời hoặc cuối video im lặng?',
      a: 'Chọn sai số giây trong Flow. Mỗi đoạn ghi số giây trong ngoặc, ví dụ (10s) thì bấm 10 giây; kiểm tra lại dòng số giây trước khi bấm tạo.',
    },
    {
      q: 'Có cần sắp xếp video trước khi gửi lại không?',
      a: 'Không cần. Gửi đủ các đoạn video, theo thứ tự nào cũng được; skill tự xếp đúng thứ tự, chèn phụ đề và ghép.',
    },
    {
      q: 'Nên dùng ảnh nhân vật thế nào?',
      a: 'Ảnh chụp từ bụng trở lên, rõ mặt. Skill không xin ảnh trong ChatGPT; ảnh chỉ đưa vào Google Flow.',
    },
    {
      q: 'Nội dung có cần kiểm tra lại không?',
      a: 'Có. Xem lại video trước khi đăng, đặc biệt các thông tin về thuốc và sức khỏe. Có lỗi thì nhắn ngay trong đoạn chat đó để skill sửa.',
    },
  ],

  support: {
    text: 'Cài skill hoặc làm video gặp khó khăn? Gọi hoặc nhắn Zalo đội hỗ trợ kèm ảnh chụp màn hình.',
    phone: '0812539539',
    phoneLabel: '0812.539.539',
  },

  ctaTitle: 'Sẵn sàng làm video hỏi đáp đầu tiên?',
  ctaText: 'Tải skill, cài vào ChatGPT trong vài phút và gõ chủ đề đầu tiên.',
};
